(function () {
  const D = window.DIAGNOSIS_DATA;
  if (!D) return;

  const $ = function (id) { return document.getElementById(id); };
  let state = { currentQ: 0, answers: [], sel: null };
  let _diagImgSeq = 0;
  let shareIntentUrl = "";

  /* ===== 集計設定 ===== */
  const SHEET_LOG_ENDPOINT = "https://script.google.com/macros/s/AKfycbwbT2_KXC6x8N0LRUrFiw9OzPkSyWM6KLZU9p10-vnmCRKd-3zoCQiVNPKGgzlopW4P/exec";

  function computeScores() {
    const scores = { b: 0, m: 0, a: 0 };
    /* 強制判定: 回答に force(結果キー) があれば、設問インデックスが大きいものを優先する。
       設問は昇順で走査するため、後ろの設問(=添字が大きい)の force で上書きされる。
       これにより優先順位は Q6 > Q4 > Q3 となる。 */
    let forcedKey = null;
    state.answers.forEach(function (opt) {
      if (!opt) return;
      scores.b += opt.score.b;
      scores.m += opt.score.m;
      scores.a += opt.score.a;
      const f = opt.force || (opt.forceVet ? "vet" : null);
      if (f) forcedKey = f;
    });
    return { scores: scores, forcedKey: forcedKey, forceVet: forcedKey === "vet" };
  }

  function getResultTypeKey() {
    const r = computeScores();
    if (r.forcedKey) return r.forcedKey;
    const b = r.scores.b;
    const m = r.scores.m;
    const a = r.scores.a;
    if (a >= m && a >= b) return "advanced";
    if (m >= b) return "intermediate";
    return "beginner";
  }

  function resultHeroUrl() {
    const rt = D.resultTypes[getResultTypeKey()];
    return (rt && rt.resultPhoto) || D.photos.heroAlt || D.photos.hero;
  }

  function revealCoverUrl() {
    const rt = D.resultTypes[getResultTypeKey()];
    return (rt && rt.revealPhoto) || (rt && rt.resultPhoto) || D.photos.heroAlt2 || D.photos.hero;
  }

  function nextDiagImageUrl(url) {
    if (!url) return url;
    _diagImgSeq += 1;
    const sep = url.indexOf("?") === -1 ? "?" : "&";
    return url + sep + "imseq=" + _diagImgSeq;
  }

  $("heroImg").src = D.photos.hero;

  function showScreen(name) {
    ["start", "question", "result"].forEach(function (n) {
      const el = $("screen-" + n);
      if (n === name) el.classList.remove("hidden-screen");
      else el.classList.add("hidden-screen");
    });
    window.scrollTo({ top: 0 });
  }

  $("btnStart").addEventListener("click", function () {
    state = { currentQ: 0, answers: [], sel: null };
    renderQuestion();
    showScreen("question");
  });

  $("btnBackStart").addEventListener("click", function () {
    if (state.sel !== null) return;
    state = { currentQ: 0, answers: [], sel: null };
    showScreen("start");
  });

  $("btnBackOne").addEventListener("click", function () {
    if (state.sel !== null) return;
    if (state.currentQ <= 0) return;
    state.currentQ -= 1;
    state.answers = state.answers.slice(0, state.currentQ);
    renderQuestion();
  });

  function renderProgress() {
    const wrap = $("qProgress");
    wrap.innerHTML = "";
    D.questions.forEach(function (_, i) {
      const s = document.createElement("div");
      s.className = "seg";
      if (i < state.currentQ) s.classList.add("done");
      if (i === state.currentQ) s.classList.add("active");
      wrap.appendChild(s);
    });
  }

  function renderQuestion() {
    const q = D.questions[state.currentQ];
    state.sel = null;
    const n2 = String(state.currentQ + 1).padStart(2, "0");
    const cur = state.currentQ + 1;
    const total = D.questions.length;
    const photoUrl = D.photos[q.key] || "";
    const photoEl = $("qPhoto");
    photoEl.style.opacity = "0";
    setTimeout(function () { photoEl.src = photoUrl; photoEl.style.opacity = "1"; }, 180);
    $("qBigLabel").textContent = "QUESTION";
    $("qBigNum").innerHTML =
      '<span class="q-meta-step-num">' +
      cur +
      '</span><span class="q-meta-step-total">/' +
      total +
      "</span>";
    // $("qPhotoTR").textContent = "No." + n2 + " / 08"; /* 非表示中: snippet の qPhotoTR をコメントアウト */
    $("qEyebrow").textContent = "QUESTION " + n2;
    $("qText").textContent = q.question;
    $("btnBackOne").classList.toggle("hidden-nav", state.currentQ <= 0);
    renderProgress();
    const list = $("qOptions");
    list.innerHTML = "";
    const letters = ["A", "B", "C", "D"];
    q.options.forEach(function (opt, i) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "q-option";
      btn.dataset.letter = letters[i];
      btn.innerHTML = '<span class="opt-text"></span><span class="opt-arr">→</span>';
      btn.querySelector(".opt-text").textContent = opt.text;
      btn.addEventListener("click", function () { handleAnswer(opt, i); });
      list.appendChild(btn);
    });
    const fa = $("fadeArea");
    fa.classList.remove("hidden");
    fa.classList.remove("q-fade-enter");
    void fa.offsetWidth;
    fa.classList.add("q-fade-enter");
  }

  function handleAnswer(opt, i) {
    if (state.sel !== null) return;
    state.sel = i;
    const buttons = $("qOptions").querySelectorAll("button");
    buttons.forEach(function (b, idx) {
      b.disabled = true;
      if (idx === i) b.classList.add("selected");
    });
    state.answers[state.currentQ] = opt;
    setTimeout(function () {
      $("fadeArea").classList.add("hidden");
      setTimeout(function () {
        if (state.currentQ < D.questions.length - 1) {
          state.currentQ += 1;
          renderQuestion();
        } else {
          runReveal();
        }
      }, 520);
    }, 520);
  }

  function getResult() {
    return D.resultTypes[getResultTypeKey()];
  }

  function runReveal() {
    const r = getResult();
    const cover = $("revealCover");
    $("revealImgEl").src = nextDiagImageUrl(revealCoverUrl());
    cover.classList.remove("hidden");
    setTimeout(function () { $("revealImg").classList.add("show"); }, 400);
    setTimeout(function () {
      renderResult(r);
      showScreen("result");
      cover.classList.add("hidden");
      $("revealImg").classList.remove("show");
    }, 3600);
  }

  function trackResult(r) {
    const ageAnswer = state.answers[0] ? state.answers[0].text : "";
    const payload = {
      diagnosis_id: "oralcare",
      result_type: r.shortType,
      result_name: r.type,
      dog_age: ageAnswer,
    };
    try {
      // Shopify カスタムピクセル（サンドボックス）へカスタムイベントを発行
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish("diagnosis_result", payload);
      }
      // 念のため: テーマに直接 gtag / dataLayer がある場合のフォールバック
      if (typeof window.gtag === "function") {
        window.gtag("event", "diagnosis_result", payload);
      }
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: "diagnosis_result" }, payload));
      }
    } catch (e) {}
  }

  function logToSheet(r) {
    if (!SHEET_LOG_ENDPOINT) return;
    try {
      const calc = computeScores();
      const payload = {
        diagnosis_id: "oralcare",
        result_type: r.shortType,
        result_name: r.type,
        answers: state.answers.map(function (a) { return a ? a.text : ""; }),
        force_vet: calc.forceVet,
        score_b: calc.scores.b,
        score_m: calc.scores.m,
        score_a: calc.scores.a,
        page: location.href,
        ua: navigator.userAgent,
      };
      fetch(SHEET_LOG_ENDPOINT, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify(payload),
      });
    } catch (e) {}
  }

  function renderResult(r) {
    $("resultBg").src = nextDiagImageUrl(resultHeroUrl());
    trackResult(r);
    logToSheet(r);
    const shareUrl = "https://petlinkmore.jp/pages/diagnosis-oralcare";
    const shareText =
      "わんちゃんのおくちケア診断の結果は…\n" +
      "「" + r.shortType + "タイプ」！\n" +
      r.type + "\n\n" +
      "みんなもやってみてね🐶";
    shareIntentUrl =
      "https://twitter.com/intent/tweet?text=" +
      encodeURIComponent(shareText) +
      "&url=" +
      encodeURIComponent(shareUrl);
    $("btnShareX").href = shareIntentUrl;
    $("resultShort").textContent = r.shortType + " TYPE";
    $("resultTitle").textContent = r.type;
    $("resultTagline").textContent = r.tagline;
    // $("resultNum").textContent = r.isWarn ? "!!" : "01"; /* 非表示中: snippet の resultNum をコメントアウトしているため */
    $("resultDesc").innerHTML = r.description;
    const tips = $("tipsList");
    tips.innerHTML = "";
    r.tips.forEach(function (t, i) {
      const row = document.createElement("div");
      row.className = "tip-row";
      row.innerHTML = '<div class="tip-num">' + String(i + 1).padStart(2, "0") + '</div><p class="tip-text"></p>';
      row.querySelector(".tip-text").textContent = t;
      tips.appendChild(row);
    });
    const plist = $("productsList");
    plist.innerHTML = "";
    r.recommendedProducts.forEach(function (pid) {
      const p = D.products[pid];
      const a = document.createElement("a");
      a.className = "product-card";
      a.href = p.url || "#";
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      const iconInner = p.image
        ? '<img src="' + p.image + '" alt="" width="84" height="84" loading="lazy">'
        : p.emoji;
      a.innerHTML = '<div class="product-icon">' + iconInner + '</div><div class="product-meta"><span class="product-tag"></span><h4 class="product-name"></h4><p class="product-desc"></p></div><div class="product-arr">›</div>';
      a.querySelector(".product-tag").textContent = p.tag;
      a.querySelector(".product-name").textContent = p.name;
      a.querySelector(".product-desc").textContent = p.desc;
      plist.appendChild(a);
    });
  }

  $("btnRestart").addEventListener("click", function () { showScreen("start"); });

  $("btnShareX").addEventListener("click", function (e) {
    if (!shareIntentUrl) return;
    e.preventDefault();
    window.open(
      shareIntentUrl,
      "share_x",
      "width=600,height=520,menubar=no,toolbar=no,scrollbars=yes,resizable=yes"
    );
  });
})();
